(() => {
    addEventListener("DOMContentLoaded", (event) => {
        let btnSearchNavbar = '';
        var searchContainer = document.getElementsByClassName('header__search-container');
        var searchForm = document.getElementsByClassName('search-form-navbar');
        var btnCloseSearcher = document.getElementById('close-btn');
        var btnResetSearcher = document.getElementById('reset-btn');
        let predectiveNavbar = document.getElementsByClassName('predictive-search-navbar');
        let results = document.getElementsByClassName('results');
        var inputSearch = '';
        let isOpen = false;
        let btnComponents = [];
        var window_width = null;

        if (btnCloseSearcher) btnComponents.push(btnCloseSearcher);

        if (searchContainer) searchContainer[0].classList.add('unactive');

        document.querySelectorAll('form[role="search"]').forEach((form) => {
            form.addEventListener('submit', normalizeSkuSearchQuery);
        });

        if (document.getElementById('search-query')) {
            inputSearch = document.getElementById('search-query');

            inputSearch.addEventListener('input', function (e) {
                if(e.target.value != '') {
                    predectiveNavbar[0].classList.add('show');
                    if (btnResetSearcher.classList.contains('hidden')) btnResetSearcher.classList.remove('hidden');
                } else {
                    predectiveNavbar[0].classList.remove('show');
                }
            });

            inputSearch.addEventListener('focus', function (e) {
                setTimeout(() => {
                    if(e.target.value == '') {
                        if(predectiveNavbar[0].classList.contains('show')) predectiveNavbar[0].classList.remove('show');

                    } else {
                        predectiveNavbar[0].classList.add('show')
                    }
                }, 1000);

                if(searchContainer) {
                    if(searchContainer[0].classList.contains('unactive')) {
                        searchContainer[0].classList.remove('unactive');
                        searchContainer[0].classList.add('active');
                    }
                }
            });

            inputSearch.addEventListener('blur', function (e) {
                if (searchContainer) {
                    if (searchContainer[0].classList.contains('active')) {
                        searchContainer[0].classList.remove('active');
                        searchContainer[0].classList.add('unactive');
                    }
                }

                if(e.target.value == '' && predectiveNavbar[0].classList.contains('show')) {
                    setTimeout(() => {
                        predectiveNavbar[0].classList.remove('show');
                    }, 1500);

                } else if(e.target.value != '' && predectiveNavbar[0].classList.contains('show')) {
                    setTimeout(() => {
                        predectiveNavbar[0].classList.remove('show');
                    }, 1500);

                }
            });
        }

        if(document.getElementById('search-btn')) {
            btnSearchNavbar = document.getElementById('search-btn');
            btnComponents.push(btnSearchNavbar);

            btnComponents.map( btn => {
                btn.addEventListener('click', function(e) {
                    validateVisibility().then((visibilty) => {
                        showFormSearch(e, visibilty);
                    });
                });
            })

        }

        if(btnResetSearcher) {
            btnResetSearcher.addEventListener('click', (e) => {
                if(predectiveNavbar[0].classList.contains('show')) {
                    predectiveNavbar[0].classList.remove('show');
                }
            });
        }

        function showFormSearch(e, visibilty) {
            return new Promise((resolve, reject) => {
                var e = window.event || e;
                e.preventDefault();
                toggleClass(visibilty);
            });
        }

        function toggleClass(visibilty) {            
            if(visibilty == true && document.getElementById('search-query').value == '') {
                searchForm[0].classList.add('open-form');
                btnCloseSearcher.classList.remove('hidden');
                if (btnCloseSearcher.classList.contains('hidden')) btnCloseSearcher.classList.remove('hidden');
                
                
            } else if(visibilty == true && document.getElementById('search-query').value != '') {
                searchForm[0].classList.add('open-form');
                btnCloseSearcher.classList.remove('hidden');
                predectiveNavbar[0].classList.add('show');
                results[0].style.opacity = '1';
                if (btnResetSearcher.classList.contains('hidden')) btnResetSearcher.classList.remove('hidden');

            } else {
                searchForm[0].classList.remove('open-form');
                btnCloseSearcher.classList.add('hidden');
                predectiveNavbar[0].classList.remove('show');
                results[0].style.opacity = '0';
                btnResetSearcher.classList.add('hidden');
            }
        }

        function validateVisibility() {
            return new Promise((resolve, reject) => {
                isOpen = !isOpen;
                resolve(isOpen);
            })
        }

        function widthActual() {
            window_width = window.innerWidth;
            if (window_width < 700) {
                if (isOpen == true) {
                    isOpen = false;
                    toggleClass(isOpen);
                }
            }
        }

        window.addEventListener("resize", (event) => {
            widthActual();
        });

        function normalizeSkuSearchQuery(event) {
            const form = event.currentTarget;
            const queryInput = form.querySelector('input[type="search"]');

            if (!queryInput) return;

            form.querySelectorAll('[data-sku-search-query]').forEach((input) => input.remove());
            queryInput.setAttribute('name', 'q');

            const query = queryInput.value.trim();
            const looksLikeSku = query.length >= 3 && /[A-Za-z]/.test(query) && /\d/.test(query) && /^[A-Za-z0-9_-]+$/.test(query);

            // Shopify finds partial SKUs on /search when the query uses a trailing wildcard.
            if (looksLikeSku && !query.endsWith('*')) {
                const skuQueryInput = document.createElement('input');

                skuQueryInput.type = 'hidden';
                skuQueryInput.name = 'q';
                skuQueryInput.value = `${query}*`;
                skuQueryInput.dataset.skuSearchQuery = 'true';

                queryInput.removeAttribute('name');
                form.appendChild(skuQueryInput);
            }
        }
    });
})()
